import actions from '../../actionTypes';

export default tag => {
  return {
    type: actions.ADD_TAG,
    tag
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/addTag.js